module.exports = __webpack_public_path__ + "img/Biology.7f1cfa6a.jpg";